import {observable, action, computed, makeObservable} from 'mobx';
import {masterStore} from './master.store.js';
import { apiService } from '../services/api.service';


class AccordionStore {

  constructor() {
    makeObservable(this);
  }

  @action toggleEverythingIsExpanded() {
    this.anythingIsExpanded ?
      this.expandedSections.clear() :
      this.expandedSections.replace(this.sections.map(section => section.sectionTitle));
  }
  @action expandAll(){
    this.expandedSections.replace(this.sections.map(section => section.sectionTitle));
  }

  @action handleSectionToggle(sectionTitle) {
    this.expandedSections.indexOf(sectionTitle) < 0 ?
      this.expandedSections.push(sectionTitle) :
      this.expandedSections.remove(sectionTitle)
  }

  @computed get sections() {
    //category without sectionTitle or sectionItems should not be rendered;
    //console.log(JSON.stringify(masterStore.newMasterStore.ContentItems.sortedContentList.filter(category => category.sectionTitle)));
   // return masterStore.newMasterStore.ContentItems.sortedContentList.filter(category => category.sectionTitle);
    return masterStore.contentItemListValue;
  }

  @computed get webinarSection(){
    return masterStore.newMasterStore.ContentItems.sortedContentList.filter((category)=>category.sectionId===15);
  }
  @computed get anythingIsExpanded() {
    return this.expandedSections.length > 0;
  }

  @computed get everythingIsExpanded() {
    return this.sections.length === this.expandedSections.length;
  }
  // @computed get isNewSecEmpty(){
  //   //console.log(JSON.stringify(this.sections));
  //   var temp= this.sections.filter((category)=> (category.sectionId === 16|| category.sectionTitle === 17));
  //   var temp2= temp.filter(category=> category.sectionItems.length!=0);
  //   //console.log(JSON.stringify(temp)+' '+JSON.stringify(temp2));
  //   return temp2.length===0;
  // }

  @action getSectionsIsAllowed(){
    const success = (response) => {
			this.isAllowed = response.is_allowed;
      console.log('from master store '+this.isAllowed);
      return this.isAllowed;
		}

		const failure = () => {
			this.isAllowed=false;
		}
    apiService.getSectionsIsAllowed().then(success,failure);
  }
  @observable isAllowed = false;
  @observable expandedSections = [];
  
}

export const accordionStore = new AccordionStore();
